import { AccredibleButtonLoadingComponentModule } from '@accredible-frontend-v2/components/button-loading';
import { AccredibleTextInputComponentModule } from '@accredible-frontend-v2/forms/text-input';
import { AccredibleInputFeedbackModule } from '@accredible-frontend-v2/new-components/input-feedback';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { RouterModule, Routes } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { PanelComponentModule } from '../../shared/components/panel/panel.component.module';
import { smartResumeLoginRedirect } from '../../shared/external/smart-resume/smartresume-login-redirect.guard';
import { NotAuthenticatedGuard } from '../../shared/guards/not-authenticated/not-authenticated.guard';
import { LoginContainer } from './login.container';

const routes: Routes = [
  {
    path: '',
    component: LoginContainer,
    canActivate: [smartResumeLoginRedirect, NotAuthenticatedGuard],
  },
];

const MATERIAL_MODULES = [MatButtonModule];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PanelComponentModule,
    AccredibleButtonLoadingComponentModule,
    AccredibleTextInputComponentModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
    RouterModule.forChild(routes),
    AccredibleInputFeedbackModule,
  ],
})
export class LoginContainerModule {}
